import Vue from 'vue'
import Router from 'vue-router'
import Empty from '@/components/empty'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/customer',
      name: 'Customer',
      component: Empty,
      meta: {
        title: '用户登录',
      },
      children: [
        {
          path: 'start',
          name: 'CustomerStart',
          component: resolve => require(['@/view/customer/start.vue'], resolve),
          meta: {
            title: '用户登录',
          },
        },
        {
          path: 'register',
          name: 'CustomerRegister',
          component: resolve => require(['@/view/customer/register.vue'], resolve),
          meta: {
            title: '用户注册',
          },
        },
        {
          path: 'result',
          name: 'CustomerResult',
          component: resolve => require(['@/view/customer/result.vue'], resolve),
          meta: {
            title: '登录成功',
          },
        }
      ]
    },
    {
      path: '/employee',
      name: 'Employee',
      component: Empty,
      meta: {
        title: '用户登录',
      },
      children: [
        {
          path: 'start',
          name: 'EmployeeStart',
          component: resolve => require(['@/view/employee/start.vue'], resolve),
          meta: {
            title: '用户登录',
          },
        },
        {
          path: 'register',
          name: 'EmployeeRegister',
          component: resolve => require(['@/view/employee/register.vue'], resolve),
          meta: {
            title: '用户注册',
          },
        },
        {
          path: 'result',
          name: 'EmployeeResult',
          component: resolve => require(['@/view/employee/result.vue'], resolve),
          meta: {
            title: '登录成功',
          },
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js